import { useState } from "react";
import axios from "axios";
import { Send } from "lucide-react";
import { formatApiErrorDetail } from "../../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const POSITIONS = ["Mutfak"];

export const CareersSection = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    position: POSITIONS[0],
    note: "",
  });
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", msg: "" });
    setLoading(true);
    try {
      await axios.post(`${API}/applications`, form);
      setStatus({
        type: "success",
        msg: "Başvurunuz alındı! En kısa sürede size dönüş yapacağız.",
      });
      setForm({ name: "", phone: "", position: POSITIONS[0], note: "" });
    } catch (err) {
      setStatus({
        type: "error",
        msg: formatApiErrorDetail(err.response?.data?.detail) || err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "mt-2 w-full border-2 border-[#1A1A1A] bg-white px-4 py-3 text-sm font-medium text-[#1A1A1A] outline-none focus:shadow-[3px_3px_0_0_#E63946]";

  return (
    <section
      id="basvuru"
      data-testid="careers-section"
      className="py-16 md:py-24"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 md:grid-cols-2 md:px-8">
        <div className="flex flex-col justify-center">
          <p className="font-script text-2xl text-[#E63946] md:text-3xl">
            Ekibe katıl
          </p>
          <h2 className="mt-2 text-4xl font-black uppercase tracking-tighter text-[#1A1A1A] sm:text-5xl">
            Deny's'de
            <br />
            çalışmak ister misin?
          </h2>
          <p className="mt-4 max-w-md text-base font-medium text-[#4A4A4A]">
            Mutfak ekibimizde yerini al. Formu doldur, biz seni arayalım.
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          data-testid="careers-form"
          className="card-print p-6 md:p-8"
        >
          <div className="space-y-5">
            <div>
              <label
                htmlFor="careers-name"
                className="text-xs font-bold uppercase tracking-wide text-[#1A1A1A]"
              >
                Ad Soyad
              </label>
              <input
                id="careers-name"
                data-testid="careers-name-input"
                type="text"
                required
                value={form.name}
                onChange={handleChange("name")}
                className={inputCls}
                placeholder="Adınız Soyadınız"
              />
            </div>
            <div>
              <label
                htmlFor="careers-phone"
                className="text-xs font-bold uppercase tracking-wide text-[#1A1A1A]"
              >
                Telefon
              </label>
              <input
                id="careers-phone"
                data-testid="careers-phone-input"
                type="tel"
                required
                value={form.phone}
                onChange={handleChange("phone")}
                className={inputCls}
                placeholder="05XX XXX XX XX"
              />
            </div>
            <div>
              <label
                htmlFor="careers-position"
                className="text-xs font-bold uppercase tracking-wide text-[#1A1A1A]"
              >
                Pozisyon
              </label>
              <select
                id="careers-position"
                data-testid="careers-position-select"
                value={form.position}
                onChange={handleChange("position")}
                className={inputCls}
              >
                {POSITIONS.map((p) => (
                  <option key={p} value={p}>
                    {p}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label
                htmlFor="careers-note"
                className="text-xs font-bold uppercase tracking-wide text-[#1A1A1A]"
              >
                Not (isteğe bağlı)
              </label>
              <textarea
                id="careers-note"
                data-testid="careers-note-input"
                rows={3}
                value={form.note}
                onChange={handleChange("note")}
                className={inputCls}
                placeholder="Kısaca kendinizden bahsedin"
              />
            </div>

            {status.msg && (
              <div
                data-testid={
                  status.type === "success"
                    ? "careers-success-message"
                    : "careers-error-message"
                }
                className={`border-2 px-4 py-3 text-sm font-bold ${
                  status.type === "success"
                    ? "border-[#1A7A3D] bg-[#1A7A3D]/10 text-[#1A7A3D]"
                    : "border-[#E63946] bg-[#E63946]/10 text-[#E63946]"
                }`}
              >
                {status.msg}
              </div>
            )}

            <button
              data-testid="careers-submit-button"
              type="submit"
              disabled={loading}
              className="btn-chunky w-full justify-center bg-[#E63946] px-6 py-3 text-base uppercase tracking-wide text-white disabled:opacity-60"
            >
              <Send size={18} strokeWidth={2.5} />
              {loading ? "Gönderiliyor..." : "Başvuruyu Gönder"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};
